import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import AlertModal from '../components/alertModal/AlertModal';
import { deleteVehicle } from '../utils/request';
import { useGarage } from './GarageContext';
import { formatPlate, plural } from './format';

export default function VehiclesPage() {
  const { loading, vehicles, error, reload } = useGarage();
  const [toRemove, setToRemove] = useState(null);
  const [removing, setRemoving] = useState(false);

  const remove = async () => {
    setRemoving(true);
    const result = await deleteVehicle(toRemove.id);
    setRemoving(false);
    setToRemove(null);
    if (result && result.status) {
      toastr.success('Veículo removido da sua garagem.');
      reload();
    } else {
      // Antes a falha mostrava toastr.success; agora avisa de verdade.
      toastr.error('Não foi possível remover o veículo. Tente novamente.');
    }
  };

  return (
    <div className='gs-stack gs-garage'>
      <header className='gs-greeting'>
        <span>Perfil</span>
        <h1>Meus veículos</h1>
      </header>

      {error && <p className='gs-notice gs-notice-error' role='alert'>{error}</p>}
      {loading && <div className='gs-skeleton gs-skeleton-row' aria-busy='true' />}

      {!loading && !error && vehicles.length === 0 && (
        <section className='gs-empty'>
          <h2>Nenhum veículo na garagem ainda</h2>
          <p>Adicione a placa para começar a ver o histórico de atendimentos.</p>
          <Link className='gs-btn gs-btn-primary' to='/client/newvehicle'>Adicionar meu primeiro veículo</Link>
        </section>
      )}

      {!loading && vehicles.length > 0 && (
        <section className='gs-section' aria-label='Veículos da garagem'>
          <div className='gs-section-head'>
            <span className='gs-muted'>{vehicles.length} {plural(vehicles.length, 'veículo', 'veículos')}</span>
            <Link to='/client/newvehicle' className='gs-add-link'>
              <FontAwesomeIcon icon={faPlus} aria-hidden='true' />
              Adicionar
            </Link>
          </div>
          <ul className='gs-tiles'>
            {vehicles.map((vehicle, index) => (
              <li key={vehicle.id || `${vehicle.licensePlate}-${index}`} className='gs-manage-row'>
                <Link className='gs-tile' to={`/client/maintances?placa=${encodeURIComponent(vehicle.licensePlate)}`}>
                  <span className='gs-tile-text'>
                    <strong>{[vehicle.brand, vehicle.model].filter(Boolean).join(' ') || 'Veículo'}</strong>
                    <span className='gs-tile-date'>
                      {formatPlate(vehicle.licensePlate)}
                      {vehicle.records.length > 0 && ` · ${vehicle.records.length} ${plural(vehicle.records.length, 'registro', 'registros')}`}
                    </span>
                  </span>
                </Link>
                <button
                  type='button'
                  className='gs-icon-btn gs-icon-btn-danger'
                  onClick={() => setToRemove(vehicle)}
                  aria-label={`Remover o veículo ${formatPlate(vehicle.licensePlate)}`}
                >
                  <FontAwesomeIcon icon={faTrashAlt} aria-hidden='true' />
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}

      <AlertModal
        show={Boolean(toRemove)}
        animation={false}
        message={toRemove ? `Remover o veículo ${formatPlate(toRemove.licensePlate)} da sua garagem?` : ''}
        onHide={() => !removing && setToRemove(null)}
        onCancel={() => !removing && setToRemove(null)}
        onSubmit={remove}
      />
    </div>
  );
}
